





























import { Component, Vue } from 'vue-property-decorator';

import Toast from '@/components/display/toast.vue';
import { ProductType } from '@/api';
import { FeedProduct } from './models';
import { FeedProductService } from './services';

import SitePicker from '@/components/site-picker.vue';

@Component({
	components: {
		SitePicker,
	},
})
export default class EditFeedProductPage extends Vue {
	public feedProduct: FeedProduct | null = null;
	public loading: boolean = true;

	private service: FeedProductService = new FeedProductService();
	private productId: number | null = null;
	private toast: Toast = new Toast();

	public async created(): Promise<void> {
		this.productId = this.productIdFromRoute();
		this.feedProduct = await this.fetchProduct();
		// Delay loading finish so it isn't janky for user.
		setTimeout(() => {
			this.loading = false;
		}, 500);
	}

	private async fetchProduct(): Promise<FeedProduct | null> {
		if (this.productId === null) {
			return null;
		}
		const productResponse = await this.service.fetchProduct(this.productId);
		if (productResponse.errorMessage) {
			this.toast.makeToast(productResponse.errorMessage, 'Error', 'danger');
			return null;
		}
		if (productResponse.product?.type !== ProductType.Feed) {
			return null;
		}
		return productResponse.product ?? null;
	}

	private productIdFromRoute(): number | null {
		const { productId } = this.$route.params;
		if (productId) {
			return parseInt(productId, 10);
		}
		return null;
	}
}
